import { render, staticRenderFns } from "./QuestionBloc.vue?vue&type=template&id=5941dd1d"
import script from "./QuestionBloc.vue?vue&type=script&lang=js"
export * from "./QuestionBloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports